<template>
    <div>
        <template v-if="crud_vendor === true && crud_vendor !==null && categories!==null && branches !==null && users !== null">
            <div class="modal fade" id="categoryModal" tabindex="-1" role="dialog" aria-labelledby="vendorEditLabel" aria-hidden="true">
                <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-body p-4">
                            <form @submit.prevent="addVendorCategory">
                                <div class="clearfix popup-head mb-4">
                                    <h2 class="mt-2 float-left">Add Vendor Category</h2>
                                    <button :disabled="categoryForm.busy" class="btn btn-primary float-right submit_form">
                                        Save & Update
                                    </button>
                                    <a href="#" class="btn btn-primary float-right mr-2" data-dismiss="modal" aria-label="Close">Cancel</a>
                                </div>
                                <div class="form-group">
                                    <label for class="label block-label">Category Name</label>
                                    <input type="text" class="form-control" name="name" v-model="categoryForm.name" :class="{ 'is-invalid': categoryForm.errors.has('name') }" autocomplete="off"/>
                                    <has-error :form="categoryForm" field="name"></has-error>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <form id="vendorForm" @submit.prevent="addVendorData">
                <div class="page-top mb-1 mb-3 clearfix">
                    <h1 class="float-left"> Add Vendor </h1>
                    <button :disabled="form.busy" class="btn btn-primary float-right submit_form">Next</button>
                    <router-link to="/vendors" class="btn btn-primary float-right mr-1"> Cancel </router-link>
                </div>
                <div class="peopple-managment-main">
                    <ul class="page-status">
                        <li class="page-status-list done">
                            <span class="status-highlighter">1</span>
                            Vendor Details
                        </li>
                        <li class="page-status-list active">
                            <span class="status-highlighter">2</span>
                            Basic Details
                        </li>
                        <li class="page-status-list">
                            <span class="status-highlighter">3</span>
                            Tax Details
                        </li>
                        <li class="page-status-list">
                            <span class="status-highlighter">4</span>
                            Payment Details
                        </li>
                    </ul>
                    <div class="people-management-inner-content p-5">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="label block-label">Vendor Type</label>
                                    <label class="radio-holder ml-0 mb-0">
                                        Individual
                                        <input v-model="form.vendor_type" type="radio" value="INDIVIDUAL" id="btn-simsim" class="payment-transfer" name="vendor_type" checked="true">
                                        <span class="checkmark"></span>
                                    </label>
                                    <label class="radio-holder mb-0">
                                        Business
                                        <input v-model="form.vendor_type" type="radio" value="BUSINESS" id="btn-bank" class="payment-transfer" name="vendor_type">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="label block-label"> Onboarding Date  </label>
                                    <datepicker name="onboarding_date" value="joinig_date" input-class="datepicker" :bootstrap-styling="true" v-model="form.onboarding_date" :class="{ 'is-invalid': form.errors.has('onboarding_date') }" placeholder="Onboarding Date"></datepicker>
                                    <has-error :form="form" field="onboarding_date"></has-error>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group dropdown">
                                    <label class="label block-label"> Category <em class="required">*</em> </label>
                                    <a class="form-control drop-value-changer" data-toggle="dropdown" href="javascript:void(0)" name="category_id" :class="{ 'is-invalid': form.errors.has('category_id') }">
                                        {{ getCatName(form.category_id) }} <span class="caret"></span>
                                    </a>
                                    <has-error :form="form" field="category_id"></has-error>
                                    <div class="dropdown-menu add-category-dropdown">
                                        <ul class="list">
                                            <li class="catory-value" v-for="category in categories" v-bind:value="category.id" v-bind:key="category.id" @click="test(category.id)"><a class="dropdown-link" href="javascript:void(0)"> {{ category.name }} </a></li>
                                        </ul>
                                        <div class="add-category">
                                            <button type="button" name="button" v-on:click="addCategory" class="dropdown-link btn btn-primary">
                                                <span class="fa fa-plus"></span>Add Category
                                                <input type="hidden" id="category_id" value="" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="label block-label"> Company POC  </label>
                                    <select v-model="form.report_to" data-live-search="true" name="report_to" id="report_to" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('report_to') }" v-if="users != null">
                                        <option value="" selected>Company POC </option>
                                        <option v-for="user in users" v-bind:value="user.id" v-bind:key="user.id"> {{ user.name }} </option>
                                    </select>
                                    <has-error :form="form" field="report_to"></has-error>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="label block-label"> Branch  </label>
                                    <select v-model="form.branch" data-live-search="true" name="branch" id="branch" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('branch') }" v-if="branches != null">
                                        <option value="" selected>Branch </option>
                                        <option v-for="branch in branches" v-bind:value="branch.id" v-bind:key="branch.id"> {{ branch.name }} </option>
                                    </select>
                                    <has-error :form="form" field="branch"></has-error>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </template>
        <template v-else-if="crud_vendor === null && categories===null && branches ===null && users === null">
             <preLoader></preLoader>
        </template>
        <template v-else-if="crud_vendor === false">
              <notAllowed></notAllowed>
        </template>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                form: new Form({
                    vendor_type : 'INDIVIDUAL',
                    report_to : '',
                    category_id : '',
                    branch : '',
                    onboarding_date : '',
                    vid : this.$route.params.id
                }),
                categoryForm: new Form({
                    name : ''
                }),
                cat_name : 'Add Category',
                categories: null,
                branches : null,
                users : null,
                crud_vendor : null
            }
        },
        methods: {
            getCatName(catId){
                let catArray = this.categories;
                var data = this.$global.checkIdExist(catId, catArray);
                if(data !== undefined){
                    return data.name;
                }else{
                    return 'Add Category';
                }
            },
            test(id){
                this.form.category_id = id;
            },
            refreshSelect(){
                $(this.$el).find('.selectpicker').selectpicker('refresh');
            },
            addVendorCategory(){
                this.categoryForm.post('/api/addVendorCategory')
                    .then(res => {
                        if(res.status == 200){
                            this.$Progress.finish();
                            this.showToastBox('success','Vendor category added successfully');
                            $("#categoryModal").modal("hide");
                            this.getCategoryData();
                        }else{
                            this.$Progress.fail();
                        }
                    })
                    .catch(err => {
                        this.$Progress.fail();
                        this.showAlertBox('error','Some problem in your form data');
                    });
            },
            addVendorData() {
                this.$Progress.start();
                this.form.post('/api/addVendorBasicDetail')
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        this.showToastBox('success','Vendor basic detail added successfully');
                        this.$router.push('/addVendorTaxDetail/'+res.data.data.id);
                    }else{
                        this.$Progress.fail();
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some problem in your form data');
                });
            },
            getCategoryData(){
                axios.get('/api/vendorCategoryData')
                .then(res => {
                    this.categories = res.data.category;
                    this.branches = res.data.branch;
                    this.users = res.data.poc;
                }).then(res=>{
                    this.refreshSelect();
                })
                .catch(err => {
                    console.log(err);
                });
            },
            getBranchData(){
                axios.get('/api/vendorBranchData')
                .then(res => {
                    this.branches = res.data.records;
                }).then(res=>{
                    this.refreshSelect();
                })
                .catch(err => {
                    console.log(err);
                });
            },
            getPOCData(){
                axios.get('/api/vendorPOCData')
                .then(res => {
                    this.users = res.data.records;
                }).then(res=>{
                    this.refreshSelect();
                })
                .catch(err => {
                    console.log(err);
                });
            },
            addCategory(){
                $("#categoryModal").modal("show");
            },
        },
        mounted() {
            this.can('crud_vendor').then(result => {
                this.crud_vendor = result.crud_vendor;
            }).then(result => {
                axios.get("/api/editVendor/" + this.$route.params.id)
                .then(res => {
                    if (res.status == 200) {
                        if(res.data.wizard_cycle == 0){
                            this.$router.push('/addVendorPersonalDetail/'+this.$route.params.id);
                        }else if(res.data.wizard_cycle == 1){
                            this.form.vendor_type = (res.data.vendor_type==null) ? 'INDIVIDUAL' : res.data.vendor_type;
                            this.form.report_to = (res.data.report_to==null) ? '' : res.data.report_to;
                            this.form.category_id = (res.data.category_id==0) ? '' : res.data.category_id;
                            this.form.branch = (res.data.branch_id==null) ? '' : res.data.branch_id;
                            this.form.onboarding_date = res.data.joining_date;
                        }else if(res.data.wizard_cycle == 2){
                            this.$router.push('/addVendorTaxDetail/'+this.$route.params.id);
                        }else if(res.data.wizard_cycle == 3){
                            this.$router.push('/addVendorPaymentDetail/'+this.$route.params.id);
                        }
                    } else {
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load data');
                    }
                })
                .catch(err => {
                    console.log(err);
                    this.$Progress.fail();
                    this.showAlertBox('error','Error to load data');
                });
                this.getCategoryData();
                $('.selectpicker').selectpicker();
            });
        }
    }

    $(document).ready(function(){
        $("body").delegate(".dropdown-menu .catory-value a", "click", function(){
            $(".drop-value-changer").html($(this).text());
        });
    });

    function saveCat(){
		var catValue = $('.cat-add-value').val();
		if (catValue === "") {
			alert('please enter category name');
		}else{
			$(".add-category-dropdown ul").append('<li class="catory-value"><a class="dropdown-link" href="javascript:void(0)">'+ catValue + '</a></li>');
			$(".modal").modal('hide');
		}
	}
</script>
